import {
  Box,
  Card,
  CardBody,
  CardFooter,
  CardProps,
  Heading,
  HeadingProps,
  ImageProps,
  Stack,
  StackProps,
} from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";

import { truncate } from "lodash";
import { Image } from "../../components";

export interface MovieCardDetailAction {
  image: string;
  title: string | ReactNode;
  badge?: string;
  detail?: string | number | ReactNode | ReactElement;
  actionButton?: ReactElement | ReactNode;
  imageProps?: ImageProps;
  cardBodyProps?: StackProps;
  cardTitleProps?: HeadingProps;
}

export function MovieCardDetailAction({
  title,
  image,
  detail,
  actionButton,
  imageProps,
  cardBodyProps,
  cardTitleProps,
  ...props
}: MovieCardDetailAction & CardProps) {
  return (
    <Card
      p="0.75rem"
      direction={{ base: "column", sm: "row" }}
      overflow="hidden"
      variant="outline"
      itemScope
      itemProp="movie-info"
      itemType="http://schema.org/Movie"
      {...props}
    >
      <Image
        objectFit="cover"
        borderRadius="md"
        itemProp="image"
        maxW={{ base: "100%", sm: "15rem" }}
        w={{ base: "100%", sm: "8rem" }}
        height={{ base: "10rem", sm: "13rem" }}
        {...imageProps}
        src={image}
        alt={typeof title === "string" ? title : "Image"}
      />

      <Stack py="0.5rem" {...cardBodyProps}>
        <CardBody px="1rem" py={0} itemScope itemProp="movie-info">
          <Heading
            size="md"
            color="surface.500"
            mb="0.5rem"
            itemProp="name"
            {...cardTitleProps}
          >
            {truncate(title, { length: 27, omission: "..." })}
          </Heading>
          <Box fontSize="sm" itemProp="description">
            <>{detail}</>
          </Box>
        </CardBody>

        {actionButton && (
          <CardFooter py={0}>
            <>{actionButton}</>
          </CardFooter>
        )}
      </Stack>
    </Card>
  );
}
